import { render, staticRenderFns } from "./LanguageChoiceQuestionType.vue?vue&type=template&id=2cb7c274&scoped=true"
import script from "./LanguageChoiceQuestionType.vue?vue&type=script&lang=js"
export * from "./LanguageChoiceQuestionType.vue?vue&type=script&lang=js"
import style0 from "./LanguageChoiceQuestionType.vue?vue&type=style&index=0&id=2cb7c274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7c274",
  null
  
)

export default component.exports